import {TrackModel} from "~~/package/mapper/track/model/TrackModel";
import {PageModel} from "~~/package/mapper/common/model/PageModel";
import {SkillAdvanceType} from "~~/package/mapper/track/model/SkillAdvanceType";
import {SkillAdvanceMyTrackModel} from "~~/package/mapper/track/model/SkillAdvanceMyTrackModel";

export class TrackHelper {
    public static mappingTrack(track: TrackModel, advanceType: SkillAdvanceType): TrackModel {
        const tempTrack = TrackModel.create(track);
        if(advanceType === SkillAdvanceType.PRACTICE) {
            track.status = track.practiceStatus;
            track.trackLevelV2DTOList.forEach(level => {
                level.status = level.practiceStatus;
            });
        }
        return tempTrack;
    }

    public static mappingPageTrackList(track: PageModel<TrackModel|SkillAdvanceMyTrackModel>, advanceType: SkillAdvanceType): PageModel<TrackModel|SkillAdvanceMyTrackModel> {
        const pageData = PageModel.create(track);
        if(advanceType === SkillAdvanceType.PRACTICE) {
            pageData.data.forEach((track: TrackModel|SkillAdvanceMyTrackModel) => {
                track.status = track.practiceStatus;
                track.trackLevelV2DTOList.forEach(level => {
                    level.status = level.practiceStatus;
                });
            });
        }
        return PageModel.create(track);
    }
}
